import React, {Component} from 'react';

export default class Modal extends Component {
    openModalHandler = (modalType) => {
        this.props.openModalHandler(modalType);
    };

    render() {
        const {title, description, icon, className, height} = this.props;
        return (this.props.isShow ?
            <div className={`popup-wrap  ${className}`}>
                <div className="popup popup_active">
                    <div className="popup__content" style={{height: height ? `${height}px` : undefined}}>
                        <span className="popup__close-btn" onClick={() => this.openModalHandler("")}/>
                        {icon ? <div className={this.props.iconClass}/> : null}
                        <p className="popup__caption">
                            <span className="cart__name">{title}</span>
                        </p>
                        <p className="popup__text popup__text_change-card">{description}</p>
                        {this.props.children}
                    </div>
                </div>
            </div> :
                null
        )
    }
}
